import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';

import BusinessServicesOverviewStatusBreakout from '../bs-overview-panel/BusinessServicesOverviewStatusBreakout';
import {
    STATUS_BREAKDOWN_CHART_PANEL_PREVIEW_IMAGE,
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
} from '../../page-framework/panel/PanelRegistry';
import { businessServiceGroupFilterId, timeRangeFilterId } from '../../filters';

const title = t`Business Services Status`;

function BusinessServicesStatusPanel() {
    return (
        <div className="flex-container">
            <BusinessServicesOverviewStatusBreakout disableSelection noSelection />
        </div>
    );
}

BusinessServicesStatusPanel.propTypes = panelPropTypes;

BusinessServicesStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 80,
    minContentHeight: 80,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'BusinessServicesStatusHistogram',
    catalogEntry: {
        category: PANEL_CATEGORIES.BUSINESS_SERVICE,
        priority: PANEL_PRIORITIES.OVERVIEW,
        title: t`Business Services Status`,
        description: t`Status counts breakdown of business services`,
        previewImage: STATUS_BREAKDOWN_CHART_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId],
        optional: [businessServiceGroupFilterId],
    },
})(BusinessServicesStatusPanel);
